module.exports = __webpack_public_path__ + "media/Grandfather.7273dc0a.mp3";